import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import * as _ from 'lodash';
import { MessageType } from '../../src';
import { NavMenuItem } from '../../src';
import { DialogService } from '../dialog-service/dialog.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'area-menu-item',
    styleUrls: ['./area-menu-item.component.scss'],
    templateUrl: './area-menu-item.component.html'
})
export class AreaMenuItemComponent implements OnInit {
    public static $name: string = 'areaMenuItem';

    public originalItem: NavMenuItem;
    public editMode: boolean = false;

    @Input() public item: NavMenuItem;

    // tslint:disable-next-line:max-line-length
    private readonly confirmDialogMessage = 'There are devices assigned to this area. Do you still want to delete this area and unassign all of its devices?';

    constructor(
        private dialogService: DialogService,
        private $state: StateService
    ) {}

    public ngOnInit() {
        this.updateOriginalItem();
    }

    /** Store a 'temp' item that we can use to reset to */
    public updateOriginalItem() {
        this.originalItem = angular.copy(this.item);
    }

    /** Reset the item to our currently stored temp item */
    public restoreItemFromOriginal() {
        this.item = angular.copy(this.originalItem);
    }

    public cancelEditMode() {
        this.restoreItemFromOriginal();
        this.toggleEditMode();
    }

    public deleteArea() {
        if (this.item.confirmDelete) {
            const dialogRef = this.dialogService.showConfirmDialog({
                data: {
                    message: this.confirmDialogMessage,
                    messageType: MessageType.Warning,
                    title: 'Unassign Controls',
                }
            });

            dialogRef.afterClosed()
                .toPromise()
                .then(confirmed => {
                    if (confirmed) {
                        this.item.deleteAction(this.item);
                    }
                });
        } else {
            this.item.deleteAction(this.item);
        }
    }

    public performEditAction() {
        if (_.isFunction(this.item.editAction)) {
            this.item.editAction(this.item).then(() => {
                this.updateOriginalItem();
            }).catch(() => {
                this.restoreItemFromOriginal();
            }).finally(() => {
                this.toggleEditMode();
            });
        }
    }

    public toggleEditMode() {
        this.editMode = !this.editMode;
    }

    public updateText(text: string) {
        this.item.text = text;
    }

    public changeState() {
        if (this.item.isEnabled) {
            this.$state.go(this.item.state, this.item.stateParams);
        }
    }
}
